"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _LearnMoreModalStylesModule = _interopRequireDefault(require("./LearnMoreModalStyles.module.scss"));

var _classnames = _interopRequireDefault(require("classnames"));

var _contract = _interopRequireDefault(require("@wisetack/assets/img/contract.svg"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var LearnMoreModal = function LearnMoreModal() {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])("modal fade", _LearnMoreModalStylesModule["default"].modal),
    id: "learnMoreModal",
    tabIndex: "-1",
    role: "dialog",
    "aria-labelledby": "tosLabel",
    "aria-hidden": "false"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])("modal-dialog", _LearnMoreModalStylesModule["default"].modalDialog),
    role: "document"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])("modal-content", _LearnMoreModalStylesModule["default"].modalContent)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])("modal-header", _LearnMoreModalStylesModule["default"].modalHeader)
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: _contract["default"],
    alt: "contract"
  }), /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "close",
    "data-test-id": "close-learnMoreModal",
    "data-dismiss": "modal",
    "aria-label": "Close"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    "aria-hidden": "true"
  }, "\xD7"))), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])("modal-body", _LearnMoreModalStylesModule["default"].modalBody)
  }, /*#__PURE__*/_react["default"].createElement("p", null, "Look out for an email from ", /*#__PURE__*/_react["default"].createElement("b", null, "Scratch Servicing"), ", our loan servicer. There you can log in with your email or mobile phone number to easily manage and pay back your Wisetack loan. You will be able to:"), /*#__PURE__*/_react["default"].createElement("ul", null, /*#__PURE__*/_react["default"].createElement("li", null, "Schedule and make payments"), /*#__PURE__*/_react["default"].createElement("li", null, "Get statements"), /*#__PURE__*/_react["default"].createElement("li", null, "View loan details"), /*#__PURE__*/_react["default"].createElement("li", null, "Edit your information"))))));
};

var _default = LearnMoreModal;
exports["default"] = _default;